import { mergeObject } from './functions';

/**
 * Masks and blocks element passed
 * @param {HTML Element} element 
 * @param {Object} settings 
 */
export function block(element, settings) {

	if (undefined === element) {
		console.warn('block element undefined');
		return;
	}

	// if the element is blocked or blocking, return
	if (element.dataset.hpyBlock === 'blocked' || element.dataset.hpyBlock === 'blocking') {
		return;
	}

	// if no settings are defined then create an empty object
	if (undefined === settings) {
		settings = {};
	}

	// create the mask element
	let mask = document.createElement('div');
	let defaults = {
		backgroundColor: '#FFFFFF',
		color: '#000000',
		opacity: '0.9',
		cursor: '',
		zIndex: 10,
		position: 'absolute',
		top: 0,
		left: 0,
		bottom: 0,
		right: 0
	};

	settings = mergeObject(settings, defaults);

	mask.classList.add('hpyBlock');

	if (settings?.message && settings.message !== '') {
		let message = document.createElement('div');
		message.classList.add('hpyBlockMessage');
		message.innerHTML = settings.message;
		mask.appendChild(message);
	}

	const computedStyles = window.getComputedStyle(element);
	// only set the parent to relative positioning if tis' not absolute
	if (computedStyles.getPropertyValue('position') != 'absolute') {
		element.style.position = 'relative';
	}

	// append the mask to the element being blocked
	element.appendChild(mask);
	element.dataset.hpyBlock = 'blocking'; // set a data attribute to show it's now blocked

	let computedStyle = window.getComputedStyle(mask); // get the initial style applied by the stylesheet
	let transitionDurationInMilliseconds = parseFloat(computedStyle.transitionDuration) * 1000;

	if (isNaN(transitionDurationInMilliseconds)) {
		return;
	}

	mask.dataset.blockTransition = transitionDurationInMilliseconds; // set the transition timing for the callback
	for (let setting in settings) {
		mask.style[setting] = settings[setting];
	}

	element.style.pointerEvents = settings.pointerEvents; // Change pointer event for element

	// set a callback to update the element data to fire after the css animation is complete
	setTimeout(() => {
		element.dataset.hpyBlock = 'blocked';
	}, transitionDurationInMilliseconds);
}

/**
 * Unblocks a previously blocked element
 * @param {HTML Element} element 
 */
export function unblock(element) {
	if (element.dataset.hpyBlock !== 'blocked' && element.dataset.hpyBlock !== 'blocking') {
		console.warn('Element not blocked');
		return;
	}

	let children = element.children;
	let mask;

	for (let i = 0; i < children.length; i += 1) {
		if (children[i].className === 'hpyBlock') {
			mask = children[i];
			break;
		}
	}
	mask.style.opacity = 0;
	element.dataset.hpyBlock = 'blocking';

	setTimeout(() => {
		element.dataset.hpyBlock = '';
		element.removeChild(mask);
		element.style.pointerEvents = '';
	}, mask.dataset.blockTransition);
}

/**
 * Toggles between blocked and unblocked depending on elements data state
 * @param {HTML Element} element 
 */
export function toggleBlock(element, settings = '') {
	if (element.dataset.hpyBlock === 'blocked') {
		unblock(element);
	} else {
		block(element, settings);
	}
}